const EVENT_DELETE_INTERVAL = 15 * 1000;
const MAXIMUM_EVENT_DURATION = 15 * 60 * 1000;
const MINIMUM_EVENT_DURATION = 2000;

export { EVENT_DELETE_INTERVAL, MAXIMUM_EVENT_DURATION, MINIMUM_EVENT_DURATION };
